import {
  GET_INITIATIVES_REQUEST,
  GET_INITIATIVES_SUCCESS,
  GET_INITIATIVES_FAILED,
  DELETE_INITIATIVE_REQUEST,
  DELETE_INITIATIVE_SUCCESS,
  DELETE_INITIATIVE_FAILED,
} from './actionTypes';

const initialState = {
  data: [],
  page: 1,
  lastPage: 1,
  loading: false,
  error: null,
  search: '',
  sort: null,
  order: null,
  perPage: 10,
};

const dashboardPetitions = (state = initialState, {
  type, error, data, meta, deletedId,
}) => {
  switch (type) {
    case GET_INITIATIVES_REQUEST:
      return { ...state, loading: true };
    case GET_INITIATIVES_SUCCESS:
      return {
        ...state,
        data,
        search: meta.search,
        page: meta.current_page,
        lastPage: meta.last_page,
        perPage: meta.per_page,
        order: meta.order,
        sort: meta.sort,
        loading: false,
      };
    case GET_INITIATIVES_FAILED:
      return { ...state, loading: false, error };
    case DELETE_INITIATIVE_REQUEST:
      return { ...state, loading: true };
    case DELETE_INITIATIVE_SUCCESS:
      return {
        ...state,
        data: state.data.filter((item) => item.id !== deletedId),
        loading: false,
      };
    case DELETE_INITIATIVE_FAILED:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default dashboardPetitions;
